import { render, staticRenderFns } from "./viewAktivenDetails.vue?vue&type=template&id=375043bc&scoped=true&"
import script from "./viewAktivenDetails.vue?vue&type=script&lang=js&"
export * from "./viewAktivenDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewAktivenDetails.vue?vue&type=style&index=0&id=375043bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375043bc",
  null
  
)

export default component.exports